module.exports = __webpack_public_path__ + "static/media/boss_cafe.01eaf4c5.png";